import { isAdminOrEmployee } from '~/utils/adminPermission';

/** Native report routes follow staff authentication; management stays role gated. */
export function isLoyaltySocieteEnabled(user: { roles?: Array<string>; email?: string | null } | null | undefined): boolean {
  return Boolean(isAdminOrEmployee(user));
}
